import React, { useContext } from 'react'
import styles from './MainBanner.module.css';

const MainBanner = (props) => {
	if (props.background_left !== "" && props.background_right !== "") {

		return (
			<div>
				<div role="img" aria-label={props.background_left_alt} style={{ backgroundImage: `url(${props.background_left})` }} className={styles.banner}>
					<div role="img" aria-label={props.background_right_alt} style={{ backgroundImage: `url(${props.background_right})` }} className={styles.banner_right}></div>
				</div>
				<div role="img" aria-label={props.background_left_alt} style={{ backgroundImage: `url(${props.background_right})` }} className={styles.banner_right_mobile}></div>
			</div>
		)
	}
	else if (props.background_left !== "" && props.background_right == "") {
		return (
			<div role="img" aria-label={props.background_left_alt} style={{ backgroundImage: `url(${props.background_left})` }} className={styles.bannerSingle}>
			</div>
		)
	}
	else {
		return (
			<>
			</>
		)
	}
}

export default MainBanner;


